module.exports = {["template-viewer-navigation"]: function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n\n	<div class="navigation">\n		<div class="navigation-arrow left offscreen"><div class="icon sprite"></div></div>\n		<div class="navigation-arrow right offscreen"><div class="icon sprite"></div></div>\n		<div class="navigation-arrow bottom offscreen"><div class="icon sprite"></div></div>\n	</div>\n\n';
}
return __p;
},}